import { axiosJsonInstance } from "@/axios.instance";
import { AxiosInstance } from "axios";

class EventTasksApi {
	private axiosJson: AxiosInstance;

	constructor() {
		this.axiosJson = axiosJsonInstance;
	}

	public async overrideActionPlan(eventId: number, actionPlanId: number): Promise<any> {
		await this.axiosJson.post(`/Tasks/OverrideActionPlan`, {
			eventId,
			actionPlanId
		});
	}
}

const eventTasksApi = new EventTasksApi();
export default eventTasksApi;